import { BaseQueryFn } from "@reduxjs/toolkit/dist/query";
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { readFromStorage, removeFromStorage } from "../webStorage";
import { HOTEL_AI_URL } from "../../config";

const axiosConfig: AxiosRequestConfig = {
    baseURL: HOTEL_AI_URL,
};

const xeroAxios = axios.create(axiosConfig);

const logout = () => {
    // removeFromStorage("accessToken");
    // removeFromStorage("refreshToken");
    // removeFromStorage("googleAccessToken");
    // removeFromStorage("googleRefreshToken");
    removeFromStorage("xeroAccessToken");
    removeFromStorage("xeroRefreshToken");
    // removeFromStorage("user");
    // removeFromStorage("role");
    window.location.reload();
    // (window as any).Intercom('shutdown');
};

// reqeust intercpetor
xeroAxios.interceptors.request.use((config) => {
    const token = readFromStorage("xeroAccessToken");
    // const isValid = validateJWT(token);
    if (token) {
        return {
            ...config,
            headers: {
                "Access-Control-Allow-Origin": "*",
                Authorization: `Bearer ${token}`,
            },
        };
    }
    return config;
});

// Add a response interceptor
xeroAxios.interceptors.response.use(
    (response) => {
        if (response?.data?.error === "No permission!") logout();
        return response;
    },
    async (error) => {
        const err = { ...error };
        if (error.response.status === 401) {
            const err = { ...error };
            const originalRequest = err.config;
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const response = await xeroAxios.post(
                        "/xero/refresh",
                        { refreshToken: localStorage.getItem("xeroRefreshToken") }
                    );
                    const { access_token, refresh_token } = response.data.tokens;
                    localStorage.setItem('xeroAccessToken', access_token);
                    localStorage.setItem("xeroRefreshToken", refresh_token);
                    const newOriginalRequest = {
                        ...originalRequest,
                        url: originalRequest.url.replace(/(accessToken=)[^&]+/, `accessToken=$${access_token}`)
                    }
                    return xeroAxios(newOriginalRequest);
                } catch (e) {
                    try {
                        const response = await xeroAxios.get("/xero/auth");
                        const { authUrl } = response.data;
                        window.location.assign(authUrl);
                    } catch (e) {
                        console.error(e);
                        logout();
                    }
                }
            } else {
                logout();
            }
        }
        return Promise.reject(err);
    }
);

export const xeroAxiosQuery =
    (): BaseQueryFn<{
        url: string;
        method: AxiosRequestConfig["method"];
        data?: AxiosRequestConfig["data"];
    }> =>
        async ({ url, method, data }) => {
            const baseUrl = axiosConfig.baseURL;
            try {
                const result = await xeroAxios({
                    url: baseUrl + url,
                    method,
                    data,
                });
                return { data: result.data };
            } catch (axiosError) {
                const err = axiosError as AxiosError;
                return {
                    error: { status: err.response?.status, data: err.response?.data },
                };
            }
        };

export default xeroAxios;
